import * as yup from 'yup'

const schema = {
  email: yup.string().email().required().trim(),
}

export const ssoValidationSchema = yup.object().shape(schema)
